import { FilterData } from 'path-shared/models/filter-data';
import { SortDirection } from '@angular/material';

export class SiglasFilter extends FilterData {
  id: string;
  descripcio: string;

  constructor(sortField: string, sortDir: SortDirection) {
    super(sortField, sortDir);
    this.id = '';
    this.descripcio = '';

    this.labels['id'] = this.i18n('Id');
    this.labels['descripcio'] = this.i18n('Descripció');
  }
}
